<template>
  <div v-loading="loading" class="edit_password">
    <!-- <div class="edit_title">重置密码</div> -->
    <div class="edit_content">
      <el-form
        ref="ruleFormRef"
        style="max-width: 600px"
        :model="ruleForm"
        status-icon
        :rules="rules"
        label-width="auto"
        class="demo-ruleForm"
      >
        <!-- 旧密码 -->
        <el-form-item label="旧密码" prop="oldPass">
          <el-input
            v-model="ruleForm.oldPass"
            type="password"
            autocomplete="off"
            show-password
          />
        </el-form-item>
        <!-- 新密码 -->
        <el-form-item label="新密码" prop="newPass">
          <el-input
            v-model="ruleForm.newPass"
            type="password"
            autocomplete="off"
            show-password
          />
        </el-form-item>
        <!-- 确认密码 -->
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            v-model="ruleForm.checkPass"
            type="password"
            autocomplete="off"
            show-password
          />
        </el-form-item>
        <el-form-item >
          <el-button class="btn" @click="resetForm(ruleFormRef)">取消</el-button>
          <el-button type="primary" @click="submitForm(ruleFormRef)">
            确认
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { editPassword } from "@/api/editPassword";
import { useRouter } from "vue-router";

const router = useRouter();
const emits = defineEmits(["cancel"]);

// 表单引用
const ruleFormRef = ref(null);
const loading = ref(false); // 加载状态

// 表单数据
const ruleForm = reactive({
  oldPass: "", // 旧密码
  newPass: "", // 新密码
  checkPass: "", // 确认密码
});

// 验证规则
const rules = {
  oldPass: [{ required: true, message: "请输入旧密码！", trigger: "blur" }],
  newPass: [{ required: true, message: "请输入新密码！", trigger: "blur" }],
  checkPass: [
    { required: true, message: "请再次输入密码！", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (value !== ruleForm.newPass) {
          callback(new Error("两次输入的新密码不一致！"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
};

// 提交表
const submitForm = (formEl) => {
  if (!formEl) return;

  formEl.validate(async (valid) => {
    if (valid) {
      console.log("表单验证成功，执行后续逻辑！");

      // 从本地存储获取用户ID
      const storedData = localStorage.getItem("id");
      try {
        const parsedData = JSON.parse(storedData);
        const userId = parsedData.value;
        console.log(userId, "userId");
        if (!userId) {
          console.error("用户ID未找到，请检查本地存储！");
          return;
        }
        let params = {
          oldPassword: ruleForm.oldPass,
          newPassword: ruleForm.newPass,
        };
        await editPassword(userId, params);
        ElMessage.success("修改密码成功！");
        // // 重定向到登录页
        redirectToLogin();
      } catch (error) {
        console.error("修改密码失败：", error);
      }
    } else {
      console.log("表单验证失败！");
    }
  });
};

// 重定向到登录页面
const redirectToLogin = () => {
  console.log("跳转到登录页面...");
  router.replace("/login");
};

// 重置表单
const resetForm = (formEl) => {
  if (!formEl) return;
  formEl.resetFields();
  emits("cancel");
};
</script>

<style lang="scss" scoped>
.edit_password {
  width: 100%;
  background-color: #fff;
  .edit_title {
    font-size: 24px;
    position: relative;
  }
  .edit_title::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 24px;
    background-color: #10b884;
    position: absolute;
    left: -6px;
    top: 2px;
  }
  .edit_content {
    width: 500px;
    margin-top: 40px;
    margin: 0 auto;
  }
  .btn{
    margin-left:150px !important;
  }
}
</style>
